import { render, staticRenderFns } from "./TabSurveys.vue?vue&type=template&id=669c521b&scoped=true"
import script from "./TabSurveys.vue?vue&type=script&lang=ts"
export * from "./TabSurveys.vue?vue&type=script&lang=ts"
import style0 from "./TabSurveys.vue?vue&type=style&index=0&id=669c521b&prod&lang=scss&scoped=true"
import style1 from "./TabSurveys.vue?vue&type=style&index=1&id=669c521b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c521b",
  null
  
)

export default component.exports